import { CheckCircle2, XCircle, Circle } from "lucide-react";

/**
 * Tri-state eMAR slot button (AM/PM). Pure UI — value comes from parent.
 * Used inside the eMAR grid on the Daily Note form.
 */
export function StatusButton({ value, onClick, slot, medId }) {
  const map = {
    administered: "border-emerald-600 bg-emerald-50 text-emerald-700",
    missed: "border-red-600 bg-red-50 text-red-700",
    none: "border-border bg-white text-muted-foreground",
  };
  const labels = { administered: "Given", missed: "Missed", none: "—" };
  const Icon = value === "administered" ? CheckCircle2 : value === "missed" ? XCircle : Circle;
  return (
    <button type="button" onClick={onClick}
      className={`flex-1 h-12 rounded-md border-2 flex items-center justify-center gap-1.5 text-sm font-semibold transition-colors ${map[value]}`}
      data-testid={`emar-${slot}-${medId}`}>
      <Icon className="w-4 h-4" /> {labels[value]}
    </button>
  );
}
